import React from 'react';
import { getProfitCopy } from './utils/getProfitCopy';
import * as S from './styled';
export const ProfitValue = ({ profit }) => {
    return (React.createElement(S.Text, { "$value": profit, "data-testid": "ProfitValue" }, getProfitCopy(profit)));
};
